export const placeholderByInputName = new Map<string, string>([
  ['credentials_certifications', 'Enter certifications'],
  ['education_medicalSchool', 'Enter medical school'],
  ['education_residency', 'Enter residency'],
  ['education_undergraduate', 'Enter undergraduate'],
  ['medical_role', 'Select medical role'],
]);
